import { NgModule } from "@angular/core";
import { ToggleActiveDirective } from "./toggle-active.directive";
import { CurrencyPipe } from "./currency.pipe";

@NgModule({
  declarations: [ToggleActiveDirective, CurrencyPipe],
  exports: [ToggleActiveDirective, CurrencyPipe],
})
export class UtilsModule {}
